import { Component } from 'react';
import {MODULE_LEVEL} from '../../data/modules';

const moduleStates = {
  [MODULE_LEVEL]: true,
};

class Module extends Component {
  render() {
    const {name, children} = this.props;
    return moduleStates[name] ? children : null;
  }
}

export default Module;
